<template>
	<div class="mdc-dialog darkModeModal" data-mdc-auto-init="MDCDialog" style="display: block;">
		<div class="mdc-dialog__container"
			style="opacity:1; transform: scale(1);padding-bottom: 150px;">
			<div aria-describedby="my-dialog-content" aria-labelledby="my-dialog-title" aria-modal="true"
				class="mdc-dialog__surface" role="alertdialog"
				style="max-width: calc(100vw - 80px)">
				<div class="pdl-24 pdr-24 pdt-3 pdb-3 d-flex">
					<i class="material-icons mdc-icon-button t-color-whiteHigh visibility-h" tabindex="0" @click="closeQuizPop()" @keypress="closeQuizPop()">close</i>
					<div class="t-color-whiteHigh t-subtitle4 t-center font-r t-center flex-grow-1 align-items-center d-flex justify-content-center"> {{$t('1087')}}
					</div>
					<i class="material-icons t-color-whiteHigh mdc-icon-button" tabindex="0" @click="closeQuizPop()" @keypress="closeQuizPop()">close</i>
				</div>
				<div class="divider-white"></div>
				<div id="my-dialog-content" class="mdc-dialog__content pda-24">

					<div class="chatReplyMessageBox d-flex justify-content-center pdt-20 pdb-19">
						<div class="d-flex align-items-center">
							<div class=""> <img alt="" class="quiz-notification-icon "
									src="/img/quiz-notification-icon.svg">
							</div>
							<div class="d-flex flex-column align-items-start">
								<div class="chatReplyMessage blue position-relative bg-commentBlue pdl-4  pdt-11 pdb-10 mgl-8 mgr-8 mgb-8 t-subtitle6 t-line-h-24 l-spacing45 t-color-whiteHigh font-r pdl-24 pdr-24">
									{{$t('1088')}} 
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="mdc-dialog__actions pdl-24 pdr-24 pdb-25 pdt-9">
					<button
						class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 w-full" tabindex="0" @click="openQuizDetail()"
						@keypress="openQuizDetail()">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">{{$t('1089')}}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="mdc-dialog__scrim" style="opacity:1;"></div>
	</div>
</template>

<script>
/**
 * 나의 학습 차시 학습창 - 타임라인 퀴즈 컨텐츠 컴포넌트(my learning lesson study - timeline quiz contents component)
 *
 * @author minkyoung.park@emcast.com
 */
import {MDCRipple} from '@material/ripple'
// Components/Mixin/Extend/API define
export default {
	props: ['currentTimelineContents'],

	mounted() {
		this.setMaterialUi();
	},

	methods: {
		// 팝업 닫기(close quiz pop)
		closeQuizPop() {
			this.$emit('closeQuizPop')
		},

		// 퀴즈 상세 열기(open quiz detail)
		openQuizDetail() {
			this.$emit('openQuizDetail')
		},

		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},
	}
}
</script>